import { render, staticRenderFns } from "./EvenementFrise.vue?vue&type=template&id=4dc24a53&"
import script from "./EvenementFrise.vue?vue&type=script&lang=js&"
export * from "./EvenementFrise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports